var shopCart = function(){
    var changeQuantityCall = {};
    var getTargetPriceCall = {};

    function setProductQuantity(productId,quantity,okHandler,errorHandler,repeatId,days){
        var kh = "p"+productId;
        if(changeQuantityCall[kh]){
            changeQuantityCall[kh].abort();
        }

        changeQuantityCall[kh] = gvf.endpoint(
            "web\\shopCartController::setProductQuantity",
            [productId,quantity,repeatId,days],
            function(resp){
                if(resp.status=="ok"){
                    triggerAddToCartEvent(resp);

                    if(resp.url){
                        window.location = resp.url;
                    }else{
                        page.callTimeoutEvent($('body'),1);
                        if(okHandler){
                            okHandler(resp);
                        }
                    }
                }else{
                    if(errorHandler){
                        errorHandler(resp);
                    }
                    if(resp.messages){
                        utils.alertEndpointResponse(resp);
                    }
                }
            }
        );
    }

    function triggerAddToCartEvent(data){
        if(data.isProEnv){
            var item = {
                item_name: data.product.name,
                item_id: data.product.code,
                price: data.product.price,
                item_category: data.product.category_name,
                quantity: parseInt(data.quantity)
            };
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: "add_to_cart",
                ecommerce: {
                    items: [item]
                }
            });
            console.log("triggerAddToCartEvent - shopCart",item);
        } else {
            console.log("triggerAddToCartEvent - shopCart (not enabled in this environment)");
        }

    }

    function getTargetPrice(productId,quantity,okHandler,errorHandler,repeatId,days){
        var kh = "p"+productId;
        if(getTargetPriceCall[kh]){
            getTargetPriceCall[kh].abort();
        }

        getTargetPriceCall[kh] = gvf.endpoint(
            "web\\shopCartController::getTargetPrice",
            [productId,quantity,repeatId,days],
            function(resp){
                if(resp.status=="ok"){
                    if(resp.url){
                        window.location = resp.url;
                    }else{
                        if(okHandler){
                            okHandler(resp);
                        }
                    }
                }else{
                    if(errorHandler){
                        errorHandler(resp);
                    }
                    if(resp.messages){
                        utils.alertEndpointResponse(resp);
                    }
                }
            }
        );
    }

    function removeProducts(okHandler,errorHandler){
        gvf.endpoint(
            "web\\shopCartController::removeProducts",
            [],
            function(resp){
                if(resp.status=="ok"){
                    if(okHandler){
                        okHandler(resp);
                    }
                }else{
                    if(errorHandler){
                        errorHandler(resp);
                    }
                    if(resp.messages){
                        utils.alertEndpointResponse(resp);
                    }
                }
            }
        );
    }

    return {
        "setProductQuantity":setProductQuantity,
        "removeProducts":removeProducts,
        "getTargetPrice":getTargetPrice
    };
}();
